import { useContext, useEffect, useState } from "react";
import BaseUrl from "../../../utils/BaseUrl";
import CustomerStyle from "../../../utils/customerStyle";
import ContentPage from "../../Content";
import separateNumber from "../../../utils/separateur";
import axios from "axios";
import DataTable from "react-data-table-component";
import ExportExcel from "../../../utils/ExcelExport";
import DetailSitesPage from "./detail_sites_page";
import { UserContext } from "../../../utils/User_check";
import { useNavigate } from "react-router-dom";
import can from "../../../utils/Can";

const url = BaseUrl();
const customerStyle = CustomerStyle();
function EcartGesites(){
      const [itemsList,setItemsList] = useState([]);
      const [itemsListFilter,setItemsListFilter] = useState([]);
      const [loading, setLoading] = useState(false);
      const [newComponent,setNewComponent] = useState('list');
      const [item,setItem] = useState(null);

      const columns = [

        // {
        //   name: "SECTEUR",
        //   selector : row => row.SecteurCommercial
        // },
    
        {
          name: "GESITE",
          selector : row => row.NomGesite
        },
        {
            name: "CONTACT",
            selector : row => row.NumeroMarchandGesite
          },
        {
          name: "SOLDE MOMO",
          selector : row => <b className="text-dark">{separateNumber(row.SoldeMomoGesite)}</b>
        },
        {
            name: "FDR SITES",
            selector : row => <b className="text-success">{separateNumber(parseInt(row.FondDeRoulementCommerciaux) + parseInt(row.FondDeRoulementGesite) )}</b>
        },
        {
          name: "MONTANT CAISSE",
          selector : row => <b className="text-success">{separateNumber(parseInt(row.MontantTotal) )}</b>
      },
        {
          name: "ECART",
          selector : row => <b className="text-danger">{separateNumber((parseInt(row.FondDeRoulementCommerciaux) + parseInt(row.FondDeRoulementGesite))-(parseInt(row.SoldeMomoGesite)+parseInt(row.MontantTotal)+parseInt(row.FondDeRoulementCommerciaux)))}</b>
        },
    
        // {
        //   name: "ACTION",
        //   selector : row => (
        //     <>
        //     <button className="btn btn-primary p-2" onClick={()=> chanhePageFunction(row)}>Voir plus</button>
           
        //     </>
        //   )
        // },
    
    
    
    ];

    const {user,role, permissions} = useContext(UserContext);
    const navigate = useNavigate();
    useEffect(()=>{
      if(user && permissions && !can(permissions,'PAGE ECART')){
          navigate('/page-no-found');
      }
  },[user]);

    useEffect(()=>{
        fetchItemsList();
      },[]);
      const fetchItemsList = async ()=>{
        setLoading(true);
        try {
            axios.get(url.base+'/get_ecart_gesites',{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{
    
                if(resp.status == 200){
                    setItemsList(resp.data);
                    setItemsListFilter(resp.data);
                }
                setLoading(false);
            })
        } catch (error) {
            setLoading(false);
        }
    }
    
    const handleFilter=(event)=>{
      const datas = itemsListFilter?.filter(row => row.NomGesite.toLowerCase().includes(event.target.value.toLowerCase() ) || row.NumeroMarchandGesite.toLowerCase().includes(event.target.value.toLowerCase())   )  ;
      setItemsList(datas);
    }

    const conditionalRowStyles = [
        {
          when: row => row.EstPrincipal == "NON", // La condition pour colorer la ligne
          style: {
            backgroundColor: 'rgba(255, 0, 0, 0.1)',
            color: 'red',
            '&:hover': {
              cursor: 'pointer',
            },
          },
        },
    ];

    const chanhePageFunction=(row)=>{
        setNewComponent('detail');
       setItem(row);
        
    }
    return (
        <>
            <ContentPage>
            <div class="page-header flex-wrap">
                    <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
                        <div class="d-flex align-items-center">
                        <a href="#">
                            <p class="m-0 pr-3 fs-4">Page</p>
                        </a>
                        <a class="pl-3 mr-4" href="#">
                            <p class="m-0 fs-4">Listes des écarts</p>
                        </a>
                        </div>
                        
                    </div>

                    <div class="header-left">
                        {/* <Link class="btn btn-primary mb-2 mb-md-0 mr-2" to="/parametres/add-commercial"> Ajouter un commercial</Link> */}
                        {/* <button class="btn btn-outline-primary mb-2 mb-md-0"> Import documents </button> */}
                    </div>
              
            </div>

            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                <div class="card-header bg-warning bg-gradient">
                      <div class="row">
                          <div class=" col-lg-3 col-md-6">
                              <input type="search" class="form-control " placeholder="Recherche..." onChange={handleFilter}/>
                          </div>
                          <div class=" col-lg-6 col-md-6">
                            <ExportExcel excelData={itemsList} filename={"LISTE DES COMMERCIAUX"}  title={"Télécharger"} color={"btn-success"}/>
                            {newComponent == 'detail' && <button type="button" className="btn btn-primary mx-2" onClick={()=> setNewComponent('list')}>Retour à la liste</button> }
                          </div>
                  </div>
                  </div>
                  <div class="card-body">
                        <h4 class="card-title">LISTE DES ECARTS</h4>
                        {newComponent == 'list' &&
                            <div class="table-responsive">
                                <DataTable 
                                    columns={columns} 
                                    data={itemsList}
                                    customStyles={customerStyle}
                                    pagination
                                    //   selectableRows
                                    progressPending={loading}
                                    conditionalRowStyles={conditionalRowStyles}
                                    progressComponent={
                                        <>
                                        <div class="text-center">
                                            <div class="spinner-border" role="status">
                                            {/* <span class="visually-hidden">Loading...</span> */}
                                            </div>
                                        </div>
                                        </>
                                    } 
                                />
                            </div>
                        }

                        {newComponent == 'detail' && 
                            <DetailSitesPage rowItem={item} />
                        }
                    
                  </div>
                </div>
              </div>
            </ContentPage>
        </>
    );

}

export default EcartGesites;